import { OptionItem } from "@interface48/api";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import React from "react";
import { JsonSchemaTypeName } from "../models";
import { processValue } from "../utils";
import { WidgetProps } from "./models";

const selectValue = (value: any, selected: any, all: any) => {
  const at = all.indexOf(value);
  const updated = selected.slice(0, at).concat(value, selected.slice(at));
  // As inserting values at predefined index positions doesn't work with empty
  // arrays, we need to reorder the updated selection to match the initial order
  return updated.sort((a: any, b: any) => all.indexOf(a) > all.indexOf(b));
};

const deselectValue = (
  value: any,
  selected: any,
  type?: JsonSchemaTypeName | JsonSchemaTypeName[],
  required?: boolean,
) => {
  return type
    ? processValue(
        selected.filter((v: any) => v !== value),
        type,
        required,
      )
    : selected.filter((v: any) => v !== value);
};

interface CheckboxesWidgetProps extends WidgetProps<Array<string | number>> {
  options: {
    enumOptions?: Array<OptionItem<string | number>>;
    inline?: boolean;
  };
}

export const CheckboxesWidgetComponent = (props: CheckboxesWidgetProps) => {
  const { disabled, options, value, schema, required, onChange } = props;
  const { enumOptions, inline } = options;

  if (!enumOptions) {
    throw Error("enumOptions must be specified.");
  }

  return (
    <FormGroup style={{ flexDirection: inline ? "row" : "column", marginTop: inline ? "12px" : "14px" }}>
      {enumOptions.map((option, index: number) => {
        const handleChange = (event: any, checked: boolean) => {
          const all = enumOptions.map(({ value: eoValue }) => eoValue);
          if (checked) {
            onChange(selectValue(option.value, value ? value : [], all));
          } else {
            onChange(deselectValue(option.value, value ? value : [], schema.type, required));
          }
        };
        const isChecked = value && value.indexOf(option.value as string | number) !== -1;
        return (
          <FormControlLabel
            key={`${index}-label`}
            control={
              <Checkbox
                key={`${index}-checkbox`}
                checked={isChecked}
                disabled={disabled}
                onChange={handleChange}
                value={option.value + ""}
              />
            }
            label={option.label}
          />
        );
      })}
    </FormGroup>
  );
};

export const CheckboxesWidget = CheckboxesWidgetComponent;
